import {
  EmptyStateStyled,
  FilePreviewStyled,
  FileViewerControlsSectionStyled,
  FileViewerStyled,
} from '@procurify/ui'
import styled from 'styled-components'

export const ExpenseLineItemDrawerDocumentStyled = styled.div`
  width: 100%;
  height: 100%;

  ${FileViewerStyled}, ${FilePreviewStyled} {
    background-color: transparent;
  }

  ${FileViewerControlsSectionStyled} {
    padding: 1rem;
  }

  ${EmptyStateStyled} {
    background-color: ${({ theme }) => theme.colors.content.contentBackground};
    border-radius: ${({ theme }) => theme.box.borderRadius(16)};
    padding: 5rem;
  }
`
